import { Component, OnInit } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import { ITenantSettings } from '../tenant-settings/models/tenant-setting';
import { TenantSettingsStoreService } from '../tenant-settings/services/tenant-settings-store.service';
import { isEnabledByTenantSettings } from 'src/app/shared/helpers/route-tenant-setting';

@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.css'],
    standalone: false
})
export class SettingComponent implements OnInit {

  constructor(
    public router: Router,
    private tenantSettingsStore: TenantSettingsStoreService
  ) { }

  childRoutes: Routes[] = [];

  // Live, so that switching a tenant option on the settings page shows or hides its menu item at once.
  tenantSettings$ = this.tenantSettingsStore.tenantSettings$;

  ngOnInit(): void {
    this.childRoutes = this.router.config.find(x => x.path == 'settings').children.filter(x => x.data.title) as Routes[];
  }

  // Same rule as the TenantSettingGuard - a hidden item is never an enterable page.
  isEnabled(route: Route, tenantSettings: ITenantSettings | null): boolean {
    return isEnabledByTenantSettings(route, tenantSettings);
  }
}
